import { FC } from 'react';

import JohnZWoznowski from 'assets/contact/john_z_woznowski.png';
import MaciejBruno from 'assets/contact/maciej_bruno.png';

import ContactOffice from '../contactOffice/ContactOffice';

interface IContactPersonInfo {
  imgSrc: string;
  name: string;
  title: string;
  email: string;
}

const ContactPersonInfo: FC<IContactPersonInfo> = ({ imgSrc, name, title, email }) => {
  return (
    <div className="tw-mb-5 tw-flex tw-w-[305px] tw-items-start tw-gap-5 sm:tw-w-0">
      <img alt="contact_person" src={imgSrc} className="tw-w-[64px] sm:tw-w-[100px]" />
      <div className="tw-flex tw-flex-col tw-items-start tw-justify-center sm:tw-gap-2">
        <p className="tw-w-max tw-text-xl tw-text-white sm:tw-text-2xl">{name}</p>
        <p className="tw-text-base tw-uppercase tw-text-skyBlue sm:tw-text-lg sm:tw-leading-5">{title}</p>
        <a
          className=" tw-text-base tw-text-turquoise tw-underline sm:tw-text-lg sm:tw-leading-5 "
          href={`mailto:${email}`}
        >
          {email}
        </a>
      </div>
    </div>
  );
};

const ContactPerson = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 sm:tw-items-start">
      <h2 className="tw-mb-7.5 tw-text-[30px] tw-font-bold tw-uppercase tw-text-white md:tw-text-[44px] xl:tw-text-5xl">
        Contact persons
      </h2>
      <ContactPersonInfo imgSrc={JohnZWoznowski} name="John Z. Woznowski" title="CEO" email="zbig@realitymeta.io" />
      <ContactPersonInfo imgSrc={MaciejBruno} name="Maciej Burno" title="CBDO" email="maciej.burno@realitymeta.io" />
    </div>
  );
};

export default ContactPerson;
